import { render, staticRenderFns } from "./MoneyInputConfig.vue?vue&type=template&id=7fa54706&scoped=true"
import script from "./MoneyInputConfig.vue?vue&type=script&lang=js"
export * from "./MoneyInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa54706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fa54706')) {
      api.createRecord('7fa54706', component.options)
    } else {
      api.reload('7fa54706', component.options)
    }
    module.hot.accept("./MoneyInputConfig.vue?vue&type=template&id=7fa54706&scoped=true", function () {
      api.rerender('7fa54706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/MoneyInputConfig.vue"
export default component.exports